module.exports = `咅:pou3
昷:wen1
罙:shen1
畐:fu2
啇:di2
覀:ya2
阝:fu3
厶:si1
龵:shou3
灬:huo3
䏍:yuan4
囬:hui2
扌:shou3
䒑:cao3
彐:ji4
戶:hu4
亠:tou2
忄:xin1
龰:zou3
纟:si1
衤:yi1
冋:jiong1
礻:shi4
卩:jie2
帀:za1
⻊:zu5
⺙:pu1
亽:ji2
戓:ge1
㠯:yi3
彡:shan1
龷:gong4
罒:wang3
钅:jin1
㐬:liu2
龺:zhuo2
迶:you4
廴:yin4
饣:shi2
㗊:ji2
犭:quan3
敫:jiao3
㔿:zou4
旲:tai2
玨:jue2
並:bing4
氶:zheng3
圡:tu3
厷:gong1
癶:bo1
仌:bing1
㚘:ban4
龹:juan3
厈:han4
冡:meng3
冎:gua3
镸:chang2
異:yi4
㐱:zhen3
犾:yin2
彑:ji4
叒:ruo4
㣺:xin1
夋:qun1
汒:mang2
辡:bian4
呙:guo1
豙:yi4
㢆:chan2
㣎:mu4
毌:guan4
疌:jie2
䩗:ba4
㝴:wan2
妟:yan4
桼:fill
復:fill
䖵:fill
㸚:fill
枼:fill
屚:fill
畺:fill
圼:fill
冝:fill
屰:fill
倠:fill
巸:fill
圤:fill
夃:fill
啚:fill
棥:fill
㓞:fill
㸒:fill
⺳:fill
厽:fill
隺:fill
粦:fill
昗:fill
欮:fill
尞:fill
⺕:fill
䖝:fill
後:fill
旉:fill
陏:fill
缊:fill
洰:fill
叕:fill
粦:fill
㡀:fill3000
弜:fill
兒:fill
䀠:fill
羕:fill
惢:fill
耴:fill
遀:fill
㧜:fill
夲:fill
歨:fill
寽:fill
睘:fill4000
習:fill
夒:fill
巜:fill
龱:fill
號:fill
貍:fill
僕:fill
匛:fill
倉:fill
敄:fill
㞢:fill
敄:fill
巤:fill
進:fill
菬:fill
騔:fill
馬:fill
臁:fill
涫:fill
瘛:fill
狊:fill
豐:fill
芏:fill
糹:fill
琊:fill
嗍:fill
殹:fill5000
孨:fill
囙:fill
皅:fill
胨:fill
鞴:fill
嗌:fill
鹨:fill
浯:fill
眔:fill
浞:fill
匃:fill
幹:fill
綝:fill
鞒:fill
崾:fill
雔:fill
硪:fill
肷:fill
鐾:fill
垡:fill
鼗:fill
馓:fill
罱:fill
泶:fill
鹱:fill
臺:fill
鳚:fill
鞔:fill
甯:fill
攵:fill
㼌:fill
艽:fill
苊:fill
葜:fill
锍:fill
矇:fill
肀:fill
類:fill
頁:fill
萠:fill
馇:fill
昬:fill
锪:fill
鞲:fill
媷:fill
聬:fill
豩:fill
槀:fill
碶:fill
貢:fill
貝:fill
穀:fill
榍:fill
蕰:fill
豂:fill
塄:fill
砘:fill6000`;
